/* eslint-disable no-restricted-properties */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-rest-params */
/* eslint-disable guard-for-in */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-throw-literal */
/* eslint-disable global-require */
/* eslint-disable no-undef */
/* eslint-disable func-names */
/**
 * Semicircle extension for L.Circle.
 * Jan Pieter Waagmeester <jieter@jieter.nl>
 *
 * This version is tested with leaflet 1.0.2
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['leaflet'], factory);
	} else if (typeof module !== 'undefined' && typeof require !== 'undefined') {
		// Node/CommonJS
		module.exports = factory(require('leaflet'));
	} else {
		// Browser globals
		if (typeof window.L === 'undefined') {
			throw 'Leaflet must be loaded first';
		}
		factory(window.L);
	}
}((L) => {
	const DEG_TO_RAD = Math.PI / 180;

	// make sure 0 degrees is up (North) and convert to radians.
	function fixAngle(angle) {
		return (angle - 90) * DEG_TO_RAD;
	}

	// rotate point [x + r, y+r] around [x, y] by `angle` radians.
	function rotated(p, angle, r) {
		return p.add(
			L.point(Math.cos(angle), Math.sin(angle)).multiplyBy(r)
		);
	}

	L.Point.prototype.rotated = function (angle, r) {
		return rotated(this, angle, r);
	};

	const semicircle = {
		options: {
			startAngle: 0,
			stopAngle: 359.9999,
			innerRadius: 0
		},

		startAngle() {
			if (this.options.startAngle < this.options.stopAngle) {
				return fixAngle(this.options.startAngle);
			}
			return fixAngle(this.options.stopAngle);
		},
		stopAngle() {
			if (this.options.startAngle < this.options.stopAngle) {
				return fixAngle(this.options.stopAngle);
			}
			return fixAngle(this.options.startAngle);
		},

		setStartAngle(angle) {
			this.options.startAngle = angle;
			return this.redraw();
		},

		setStopAngle(angle) {
			this.options.stopAngle = angle;
			return this.redraw();
		},

		setInnerRadius(radius) {
			this.options.innerRadius = radius;
			return this.redraw();
		},

		setDirection(direction, degrees) {
			if (degrees === undefined) {
				degrees = 10;
			}
			this.options.startAngle = direction - (degrees / 2);
			this.options.stopAngle = direction + (degrees / 2);

			return this.redraw();
		},
		getDirection() {
			return this.stopAngle() - (this.stopAngle() - this.startAngle()) / 2;
		},

		isSemicircle() {
			const { startAngle } = this.options;
			const { stopAngle } = this.options;

			return (
				!(startAngle === 0 && stopAngle > 359)
				&& !(startAngle === stopAngle)
			);
		},
		_containsPoint(p) {
			function normalize(angle) {
				while (angle <= -Math.PI) {
					angle += 2.0 * Math.PI;
				}
				while (angle > Math.PI) {
					angle -= 2.0 * Math.PI;
				}
				return angle;
			}
			let angle = Math.atan2(p.y - this._point.y, p.x - this._point.x);
			const nStart = normalize(this.startAngle());
			let nStop = normalize(this.stopAngle());
			if (nStop <= nStart) {
				nStop += 2.0 * Math.PI;
			}
			if (angle <= nStart) {
				angle += 2.0 * Math.PI;
			}
			return (
				nStart < angle && angle <= nStop
				&& p.distanceTo(this._point) <= this._radius + this._clickTolerance()
			);
		}
	};

	L.SemiCircle = L.Circle.extend(semicircle);
	L.SemiCircleMarker = L.CircleMarker.extend(semicircle);

	L.semiCircle = function (latlng, options) {
		return new L.SemiCircle(latlng, options);
	};
	L.semiCircleMarker = function (latlng, options) {
		return new L.SemiCircleMarker(latlng, options);
	};

	const _updateCircleSVG = L.SVG.prototype._updateCircle;
	const _updateCircleCanvas = L.Canvas.prototype._updateCircle;

	L.SVG.include({
		_updateCircle(layer) {
			// If we want a circle, we use the original function
			if (!(layer instanceof L.SemiCircle || layer instanceof L.SemiCircleMarker)
				|| !layer.isSemicircle()) {
				return _updateCircleSVG.call(this, layer);
			}
			if (layer._empty()) {
				return this._setPath(layer, 'M0 0');
			}

			const p = layer._map.latLngToLayerPoint(layer._latlng);
			const r = layer._radius;
			const r2 = Math.round(layer._radiusY || r);
			const start = p.rotated(layer.startAngle(), r);
			const end = p.rotated(layer.stopAngle(), r);

			const largeArc = (layer.options.stopAngle - layer.options.startAngle >= 180) ? '1' : '0';

			if (layer.options.innerRadius === 0 || layer.options.innerRadius === undefined) {
				const d = `M${p.x},${p.y
					// line to first start point
				}L${start.x},${start.y
				}A ${r},${r2},0,${largeArc},1,${end.x},${end.y
				} z`;

				this._setPath(layer, d);
			} else {
				if (layer.options.innerRadius >= layer.options.radius) {
					this._mRadius = layer.options.radius - 1;
				} else {
					this._mRadius = layer.options.innerRadius;
				}

				const { lng } = layer._latlng;
				const { lat } = layer._latlng;
				const map = layer._map;
				const { crs } = map.options;

				const d = Math.PI / 180;
				const latR = (this._mRadius / Earth.R) / d;
				const top = map.project([lat + latR, lng]);
				const bottom = map.project([lat - latR, lng]);
				const p2 = top.add(bottom).divideBy(2);
				const lat2 = map.unproject(p2).lat;
				let lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d))
					/ (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

				if (Number.isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}

				this._point = p2.subtract(map.getPixelOrigin());
				this._radius = Number.isNaN(lngR) ? 0 : p2.x - map.project([lat2, lng - lngR]).x;
				this._radiusY = p2.y - top.y;

				const innerStart = p.rotated(layer.startAngle(), this._radius);
				const innerEnd = p.rotated(layer.stopAngle(), this._radius);
				const innerR2 = Math.round(this._radiusY || this._radius);

				const path = `M${innerStart.x},${innerStart.y
					// line to first start point
				}L${start.x},${start.y
				}A ${r},${r2},0,${largeArc},1,${end.x},${end.y
				}L ${innerEnd.x},${innerEnd.y
				}M${innerStart.x},${innerStart.y
				}A ${this._radius},${innerR2},0,${largeArc},1,${innerEnd.x},${innerEnd.y
				}`;

				this._setPath(layer, path);
			}
		}
	});

	L.Canvas.include({
		_updateCircle(layer) {
			// If we want a circle, we use the original function
			if (!(layer instanceof L.SemiCircle || layer instanceof L.SemiCircleMarker)
				|| !layer.isSemicircle()) {
				return _updateCircleCanvas.call(this, layer);
			}

			const p = layer._point;
			const ctx = this._ctx;
			const r = layer._radius;
			const s = (layer._radiusY || r) / r;
			const start = p.rotated(layer.startAngle(), r);

			// comentado porque dá erro
			// console.log(layer)
			// console.log(this)
			// this._drawnLayers[layer._leaflet_id] = layer;

			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}

			if (layer.options.innerRadius === 0 || layer.options.innerRadius === undefined) {
				ctx.beginPath();
				ctx.moveTo(p.x, p.y);
				ctx.lineTo(start.x, start.y);
				ctx.arc(p.x, p.y, r, layer.startAngle(), layer.stopAngle());
				ctx.lineTo(p.x, p.y);
			} else {
				if (layer.options.innerRadius >= layer.options.radius) {
					this._mRadius = layer.options.radius - 1;
				} else {
					this._mRadius = layer.options.innerRadius;
				}

				const { lng } = layer._latlng;
				const { lat } = layer._latlng;
				const map = layer._map;
				const { crs } = map.options;

				const d = Math.PI / 180;
				const latR = (this._mRadius / Earth.R) / d;
				const top = map.project([lat + latR, lng]);
				const bottom = map.project([lat - latR, lng]);
				const p2 = top.add(bottom).divideBy(2);
				const lat2 = map.unproject(p2).lat;
				let lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d))
					/ (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

				if (Number.isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}

				this._point = p2.subtract(map.getPixelOrigin());
				this._radius = Number.isNaN(lngR) ? 0 : p2.x - map.project([lat2, lng - lngR]).x;
				this._radiusY = p2.y - top.y;

				const innerStart = p.rotated(layer.startAngle(), this._radius);
				const innerEnd = p.rotated(layer.stopAngle(), this._radius);

				ctx.beginPath();
				ctx.moveTo(innerStart.x, innerStart.y);
				ctx.lineTo(start.x, start.y);
				ctx.arc(p.x, p.y, r, layer.startAngle(), layer.stopAngle());
				ctx.lineTo(innerEnd.x, innerEnd.y);
				ctx.arc(p.x, p.y, this._radius, layer.startAngle(), layer.stopAngle());
			}

			if (s !== 1) {
				ctx.restore();
			}

			this._fillStroke(ctx, layer);
		}
	});
}));

// @function extend(dest: Object, src?: Object): Object
// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
function extend(dest) {
	let i; let j; let len; let
		src;

	for (j = 1, len = arguments.length; j < len; j++) {
		src = arguments[j];
		for (i in src) {
			dest[i] = src[i];
		}
	}
	return dest;
}

const CRS = {
	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	// Projects geographical coordinates into pixel coordinates for a given zoom.
	latLngToPoint(latlng, zoom) {
		const projectedPoint = this.projection.project(latlng);
		const scale = this.scale(zoom);

		return this.transformation._transform(projectedPoint, scale);
	},

	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	// zoom into geographical coordinates.
	pointToLatLng(point, zoom) {
		const scale = this.scale(zoom);
		const untransformedPoint = this.transformation.untransform(point, scale);

		return this.projection.unproject(untransformedPoint);
	},

	// @method project(latlng: LatLng): Point
	// Projects geographical coordinates into coordinates in units accepted for
	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	project(latlng) {
		return this.projection.project(latlng);
	},

	// @method unproject(point: Point): LatLng
	// Given a projected coordinate returns the corresponding LatLng.
	// The inverse of `project`.
	unproject(point) {
		return this.projection.unproject(point);
	},

	// @method scale(zoom: Number): Number
	// Returns the scale used when transforming projected coordinates into
	// pixel coordinates for a particular zoom. For example, it returns
	// `256 * 2^zoom` for Mercator-based CRS.
	scale(zoom) {
		return 256 * Math.pow(2, zoom);
	},

	// @method zoom(scale: Number): Number
	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	// factor of `scale`.
	zoom(scale) {
		return Math.log(scale / 256) / Math.LN2;
	},

	// @method getProjectedBounds(zoom: Number): Bounds
	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	getProjectedBounds(zoom) {
		if (this.infinite) { return null; }

		const b = this.projection.bounds;
		const s = this.scale(zoom);
		const min = this.transformation.transform(b.min, s);
		const max = this.transformation.transform(b.max, s);

		return new Bounds(min, max);
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates.

	// @property code: String
	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	//
	// @property wrapLng: Number[]
	// An array of two numbers defining whether the longitude (horizontal) coordinate
	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	//
	// @property wrapLat: Number[]
	// Like `wrapLng`, but for the latitude (vertical) axis.

	// wrapLng: [min, max],
	// wrapLat: [min, max],

	// @property infinite: Boolean
	// If true, the coordinate space will be unbounded (infinite in both axes)
	infinite: false,

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where lat and lng has been wrapped according to the
	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	wrapLatLng(latlng) {
		const lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng;
		const lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat;
		const { alt } = latlng;

		return new LatLng(lat, lng, alt);
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	// that its center is within the CRS's bounds.
	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	wrapLatLngBounds(bounds) {
		const center = bounds.getCenter();
		const newCenter = this.wrapLatLng(center);
		const latShift = center.lat - newCenter.lat;
		const lngShift = center.lng - newCenter.lng;

		if (latShift === 0 && lngShift === 0) {
			return bounds;
		}

		const sw = bounds.getSouthWest();
		const ne = bounds.getNorthEast();
		const newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift);
		const newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);

		return new LatLngBounds(newSw, newNe);
	}
};

/*
 * @namespace CRS
 * @crs L.CRS.Earth
 *
 * Serves as the base for CRS that are global such that they cover the earth.
 * Can only be used as the base for other CRS and cannot be used directly,
 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
 * meters.
 */

const Earth = extend({}, CRS, {
	wrapLng: [-180, 180],

	// Mean Earth Radius, as recommended for use by
	// the International Union of Geodesy and Geophysics,
	// see http://rosettacode.org/wiki/Haversine_formula
	R: 6371000,

	// distance between two geographical points using spherical law of cosines approximation
	distance(latlng1, latlng2) {
		const rad = Math.PI / 180;
		const lat1 = latlng1.lat * rad;
		const lat2 = latlng2.lat * rad;
		const sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2);
		const sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2);
		const a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon;
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return this.R * c;
	}
});
